"use strict";

import React, { PropTypes } from 'react';
import Map from './Map.js';
import Details from './Details.js';

const partyMap = {
  'B': 'Båda partier',
  'R': 'Republikanerna',
  'D': 'Demokraterna'
};

const kindMap = {
  'P': 'Primärval',
  'C': 'Nomineringsval',
  'CO': 'Konvent'
};

const icons = {
  unknown: <i className="svt_icon svt_icon--question"></i>
};

const Primary = React.createClass({
  displayName: "Primary",
  propTypes: {
    item: PropTypes.object
  },
  getInitialState() {
    return {
      showDetails: false,
      displayMap: false
    };
  },
  componentDidMount() {
    this.displayMap();
  },
  handleClick() {
    if (!this.props.item.done && !this.props.item.ongoing) return;
    this.setState({ showDetails: !this.state.showDetails });
  },
  displayMap() {
    this.setState({
      displayMap: true
    });
  },

  constructWinner(party) {
    const person = this.props.item.results[party][0];
    const winnerImg = `img/new/${person.name.replace(' ', '_').toLowerCase()}.jpg`;
    const css = require('./Primary.scss');

    if (person.delegates) {
      return <img src={winnerImg} className={css.winnerImg} />;
    } else {
      if (this.props.item.party === 'B' || this.props.item.party.toLowerCase() === party[0].toLowerCase()) {
        return icons.unknown;
      } else {
        return '';
      }
    }
  },

  constructWinnerName(party) {
    const person = this.props.item.results[party][0];
    const css = require('./Primary.scss');

    if (person.delegates) {
      const [firstName, lastName] = person.name.split(' ');
      return (
        <p className={css.winnerName}>
           <span className={css.winnerFirstName}>{firstName} </span>
           <span className={css.winnerLastName}>{lastName}</span>
         </p>
      );
    }

    return '';
  },

  constructDate() {
    const [day, month] = this.props.item.date.split(' ');
    const css = require('./Primary.scss');

    return (
      <p className={css.date}>
        <span className={css.day}>{day}</span>
        <span>{month}</span>
      </p>
    );
  },

  render() {
    const detailsDiv = <Details item={this.props.item} />;
    const details = this.state.showDetails ? detailsDiv : '';
    const isDone = this.props.item.done;
    const isOngoing = this.props.item.ongoing;
    const isDoneOrOngoing = isDone || isOngoing ? true : false;
    const election = this.props.item;
    const isFirst = election.firstForDate;
    var border = '5px solid #ccc';
    var readMore;
    const css = require('./Primary.scss');


    if (isDoneOrOngoing) {
      if (this.state.showDetails) {
        readMore = <p className={css.readMore}><i className="svt_icon svt_icon--minus-square"></i> Dölj</p>;
      } else {
        readMore = <p className={css.readMore}><i className="svt_icon svt_icon--plus-square"></i> Läs mer</p>;
      }
    } else {
      readMore = '';
    }

    if (election.party === 'R') { border = '5px solid #a90213'; }
    if (election.party === 'D') { border = '5px solid #0064a5'; }

    var clsName = css.primList;
    var ongoingStamp = <span className={css.ongoingStamp}> – pågående</span>;

    if (isDoneOrOngoing) { clsName += ' ' + css.primListDone; }
    if (isFirst) { clsName += ' ' + css.primListFirst; }

    return (
      <div className={clsName}
           tabIndex="1"
           onClick={this.handleClick}
           style={{borderLeft: border}}>
        <ul className={css.primListList}>
          <li className={css.primListItemDate}>{isFirst ? this.constructDate() : ''}</li>
          <li className={css.primListItemMap}>
            {
              this.state.displayMap &&
              <Map highlighted={election.state_short.toLowerCase()} />
            }
          </li>
          <li className={css.primListItemState}><p className={css.stateName}>{election.state}</p>
            <p className={css.text}>{kindMap[election.kind]} {isOngoing && ongoingStamp}</p>
            {readMore}
          </li>
          <li className={css.rep + ' ' + css.primListItemWinner}>
            {this.constructWinner('republicans')}
            {this.constructWinnerName('republicans')}
          </li>
          <li className={css.dem + ' ' + css.primListItemWinner}>
            {this.constructWinner('democrats')}
            {this.constructWinnerName('democrats')}
          </li>
          {details}
        </ul>
      </div>
    );
  }
});

export default Primary;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Primary.js
 **/